import React, { useState, useEffect } from 'react';
import { api_contractorResumeUpdate, api_contractorResumeDetail } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { ReqResumeEdit, RespResumeDetail, ReqResumeDetail, RespResumeOtherData } from '../../../../item/ItemResume';
import moment from 'moment';
import { ContractorResumeFamily, OtherData_family } from '../ContractorResume/ContractorResumeFamily';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { ContractorResumeBase, OtherData_base } from '../ContractorResume/ContractorResumeBase';
import { ContractorResumeEducation, OtherData_education } from '../ContractorResume/ContractorResumeEducation';
import { ContractorResumeWorkExperiences, OtherData_workExperiences } from '../ContractorResume/ContractorResumeWorkExperiences';
import { OtherData_payrollMethod } from '../ContractorResume/ContractorResumePayrollMethod';
import { getval2Token } from '../../../Login/Auth';
import { ContractorResumeAttachment, OtherData_attachment } from '../ContractorResume/ContractorResumeAttachment';
import { SubmitButton } from '../../Res/BaseButton';
import { ContentBox } from '../ContentBox';

export function RecruitmentContractorStatusResume({ rId, setIsLoading, isAdmin=false }) {
    const [isEdit, setIsEdit] = useState(false)
    // const [tokenId, setTokenId] = useState("")
    const [resumeId, setResumeId] = useState("")
    const [idNumber, ssetIdNumber] = useState("")
    const [birthday, setBirtyday] = useState("")
    const [base, setBase] = useState({})
    const [family, setFamily] = useState({})
    const [education, setEducation] = useState({})
    const [payrollMethod, setPayrollMethod] = useState({})
    const [attachment, setAttachment] = useState({})
    const [workExperiences, setWorkExperiences] = useState({})

    useEffect(() => {
        if (rId !== undefined && rId !== resumeId) {
            // var obj = getval2Token("recruitmentContractorStatus", id)
            // console.log(obj)
            // var rId = getval2Token("resumeId", id)
            setResumeId(rId)
            // setTokenId(id)
            var mReqResumeDetail = new ReqResumeDetail({
                resumeId: rId,
                // tokenId: id
            })
            getDetail(mReqResumeDetail)
        }
    }, [rId])

    function getDetail(mReqResumeDetail) {
        setIsLoading(true)
        //console.log(mReqResumeDetail)
        api_contractorResumeDetail({
            mReqResumeDetail,
            success: (result) => {
                //console.log(result)
                var mRespResumeDetail = new RespResumeDetail({})
                mRespResumeDetail.fromJson(result.info)
                setResumeId(mRespResumeDetail.resumeId)
                ssetIdNumber(mRespResumeDetail.idNumber)
                var bDay = moment(mRespResumeDetail.birthday).format('YYYY-MM-DD')
                setBirtyday(bDay)
                //console.log(mRespResumeDetail.resumeDatas.workExperiences)
                //console.log(mRespResumeDetail.resumeDatas.attachment)
                setBase(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_base,
                    resumeData: mRespResumeDetail.resumeDatas.base
                }))
                setFamily(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_family,
                    resumeData: mRespResumeDetail.resumeDatas.family
                }))
                setEducation(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_education,
                    resumeData: mRespResumeDetail.resumeDatas.education
                }))
                setWorkExperiences(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_workExperiences,
                    resumeData: mRespResumeDetail.resumeDatas.workExperiences
                }))
                setAttachment(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_attachment,
                    resumeData: mRespResumeDetail.resumeDatas.attachment
                }))
                setPayrollMethod(setResumeOtherData({
                    resumeId: mRespResumeDetail.resumeId,
                    resumeKey: OtherData_payrollMethod,
                    resumeData: mRespResumeDetail.resumeDatas.payrollMethod
                }))

                //setOtherData(mRespResumeDetail.otherData)
                setIsLoading(false)
            },
            failure: (err) => {
                //console.log(err)
                setIsLoading(false)
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err.message,
                }).then(() => {
                    window.history.go(-1)
                })
            }
        })
    }

    function setResumeOtherData({ resumeId, resumeKey, resumeData }) {
        if (resumeData === undefined) {
            return new RespResumeOtherData({
                resumeId,
                resumeKey
            })
        }
        return resumeData
    }

    async function toSave(birthday) {
        var mReqResumeEdit = new ReqResumeEdit({
            resumeId,
            birthday
        })
        try {
            await api_contractorResumeUpdate({ mReqResumeEdit })
            console.log("OK")
        } catch (error) {
            console.log(error)
        }
    }

    function toEdit() {
        setIsEdit(true)
    }

    function toDetail(){
        setIsEdit(false)
    }

    // function toHistory() {
    //     window.location.assign("/ContractorResumeDetail/" + id);
    // }

    var precautionsTitle = "外派員工履歷表 注意事項"
    var precautionsContent =
        <>
            <div className="row">
                <div className="col-md-12">
                    <p className="text-success">親愛的招募人員<br></br>
                        1. 附件應該要注意XXXXXX。<br></br>
                        2. 外派員工填寫的資料您無法變更。<br></br>
                        3. 如果外派員工資料有誤，請通知您的主管。<br></br>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {!isEdit?
                    <SubmitButton name={"進行編輯"} action={toEdit} isRight={true} />:
                    <SubmitButton name={"完成編輯"} action={toDetail} isRight={true} />
                    }
                </div>
            </div>
        </>

    return (
        <>
            <ContentBox title={precautionsTitle} titleSize={6} content={precautionsContent} hasDrawer={false} />
            <ContractorResumeBase
                rId={resumeId}
                idN={idNumber}
                bDay={birthday}
                base={base}
                setIsLoading={setIsLoading}
                toSave={toSave}
                toEdit={toEdit}
                isEdit={isAdmin&isEdit}
                hosTools={false}
            />
            <ContractorResumeFamily
                rId={resumeId}
                familys={family}
                setIsLoading={setIsLoading}
                isEdit={isAdmin&isEdit}
            />
            <ContractorResumeEducation
                rId={resumeId}
                education={education}
                setIsLoading={setIsLoading}
                isEdit={isAdmin&isEdit}
            />
            <ContractorResumeWorkExperiences
                rId={resumeId}
                workExperiences={workExperiences}
                setIsLoading={setIsLoading}
                isEdit={isAdmin&isEdit}
            />
            <ContractorResumeAttachment
                rId={resumeId}
                attachment={attachment}
                setIsLoading={setIsLoading}
                isEdit={isEdit}
            />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}